import { createStyles, makeStyles } from '@material-ui/core'

export default makeStyles(() =>
  createStyles({
    close: {
      color: '#949494 !important',
    },
    title: {
      fontWeight: 500,
      fontSize: '36px',
      marginTop: '0',
      paddingTop: '60px',
      textAlign: 'center',
    },
    gradiantStrawberry: {
      backgroundColor: '#FF7A5E',
      backgroundImage: 'linear-gradient(#FF7AAB, #FF7A5E)',
      backgroundSize: '100%',
      '-webkit-background-clip': 'text',
      '-moz-background-clip': 'text',
      '-webkit-text-fill-color': 'transparent',
      '-moz-text-fill-color': 'transparent',
    },
    gradiantTurquoise: {
      backgroundColor: '#00A3C7',
      backgroundImage: 'linear-gradient(#00B496, #00A3C7)',
      backgroundSize: '100%',
      '-webkit-background-clip': 'text',
      '-moz-background-clip': 'text',
      '-webkit-text-fill-color': 'transparent',
      '-moz-text-fill-color': 'transparent',
    },
    gradiantSunset: {
      backgroundColor: '#FFD200',
      backgroundImage: 'linear-gradient(#FF7A5E, #FFD200)',
      backgroundSize: '100%',
      '-webkit-background-clip': 'text',
      '-moz-background-clip': 'text',
      '-webkit-text-fill-color': 'transparent',
      '-moz-text-fill-color': 'transparent',
    },
    gradiantLemonlime: {
      backgroundColor: '#00B496',
      backgroundImage: 'linear-gradient(#FFD200, #C2CB24, #29B97E, #00B496)',
      backgroundSize: '100%',
      '-webkit-background-clip': 'text',
      '-moz-background-clip': 'text',
      '-webkit-text-fill-color': 'transparent',
      '-moz-text-fill-color': 'transparent',
    },
    subtitle: { padding: '12px 36px 24px', textAlign: 'center' },
    sectionHeader: { color: '#6E3264', textAlign: 'center', fontWeight: 500 },
    sectionDescription: {
      color: '#666',
      fontSize: '16px',
      textAlign: 'center',
    },
    sectionCta: {
      width: '240px',
    },
    promoImageButton: {
      background: 'none', // To remove the button's default styles
      border: 'none',
      padding: 0,
    },
    promoWaveImage: {
      width: '100%',
      padding: '16px 0',
    },
    promoGuidesImage: {
      width: '100%',
      padding: '16px',
    },
    promoWaveBackground: {
      backgroundColor: '#6E3264',
      backgroundImage: 'linear-gradient(#00A3C7, #6E3264)',
      backgroundSize: '100%',
      paddingTop: '35px',
      position: 'relative',
      margin: '32px 0 48px',
      display: 'flex',
    },
    phoneImage: {
      width: '46%',
    },
    sectionText: {
      padding: '48px 24px',
      color: 'white',
    },
    sectionTextTitle: {
      fontWeight: 500,
      fontSize: '24px',
    },
    sectionTextSubtitle: {
      fontSize: '16px',
    },
  })
)
